export type InboundReplyTemplateCategory = string;

export type InboundReplyTemplate = {
  id?: string;
  key: string;
  scope?: 'COMPANY' | 'PERSONAL';
  categoryKey?: string | null;
  categoryName?: string | null;
  isDefault?: boolean;
  suggestionRules?: any;
  label: string;
  category: InboundReplyTemplateCategory;
  previewName: string;
  html: string;
};

export const INBOUND_REPLY_TEMPLATES: InboundReplyTemplate[] = [
  {
    key: 'acknowledgement',
    label: 'Acknowledgement',
    category: 'GENERAL',
    previewName: 'Quick receipt confirmation',
    html: '<p>{{greetingLine}}</p><p>Thank you for your email regarding <strong>{{subject}}</strong>. We have received your request and our team is now reviewing the details.</p><p>We will revert shortly with the best available option.</p>',
  },
  {
    key: 'need_details',
    label: 'Need Details',
    category: 'NEED INFO',
    previewName: 'Ask for missing travel details',
    html: '<p>{{greetingLine}}</p><p>Thank you for your message. To finalize your request, please confirm:</p><ul><li>Travel date and preferred time</li><li>Passenger count</li><li>Route (from/to)</li></ul><p>Once we receive these details, we will proceed immediately.</p>',
  },
  {
    key: 'sent_quote',
    label: 'Sent Quote',
    category: 'QUOTE',
    previewName: 'Share quote and request approval',
    html: '<p>{{greetingLine}}</p><p>We have prepared your quote and shared the details for your review.</p><p>Please confirm if we should proceed, or let us know if you need any revisions.</p>',
  },
  {
    key: 'follow_up',
    label: 'Follow Up',
    category: 'FOLLOW-UP',
    previewName: 'Nudge client for next step',
    html: '<p>{{greetingLine}}</p><p>Just following up on our previous email sent by {{senderName}} from {{mailboxEmail}} regarding <strong>{{subject}}</strong>.</p><p>Please let us know your preferred next step so we can proceed accordingly.</p>',
  },
];
